import React, { useRef, useState } from "react";
import useOnClickOutside from "../../../../hooks/useOnClickOutside.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import CustomPopup from "../Popups/CustomPopup.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";

const MailRecipientsComponent = ({ recipientsList, top = 20 }) => {
  const [showRecipients, setShowRecipients] = useState(false);
  const { getTextByKey } = useContent();

  const ref = useRef();
  useOnClickOutside(ref, () => setShowRecipients(false));

  return recipientsList?.length > 0 ? (
    <div className="mail-recipients">
      <span>
        {recipientsList[0] || getTextByKey("mail-uploaded-as-link-text")}
      </span>
      {recipientsList?.length > 1 ? (
        <div
          className="all-recipients"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowRecipients((prev) => !prev);
          }}
          ref={ref}
        >
          +{recipientsList?.length - 1}
          <Icon name="arrow-down-solid" />
          <CustomPopup showState={showRecipients} topPosition={top}>
            <div className="full-recipents-list">
              <div className="left-side">TO</div>
              <div className="right-side">
                {recipientsList.map((item, i) => (
                  <div className="mail-adress" key={item}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </CustomPopup>
        </div>
      ) : null}
    </div>
  ) : null;
};

export default MailRecipientsComponent;
